import { render } from "./GalleryContent.vue?vue&type=template&id=1f4ad3e7"
import script from "./GalleryContent.vue?vue&type=script&lang=js"
export * from "./GalleryContent.vue?vue&type=script&lang=js"

import "./GalleryContent.vue?vue&type=style&index=0&id=1f4ad3e7&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__